"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldPasswordCompact = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const smartlabel_1 = __importDefault(require("../../smartlabel/smartlabel"));
const textinput_1 = __importDefault(require("../../textinput/textinput"));
const visibility_1 = __importDefault(require("../../iconbutton/visibility/visibility"));
const status_1 = require("../../constants/status");
class FieldPasswordCompact extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            inputHasFocus: false
        };
        this.id = lodash_uniqueid_1.default('fpc_');
        this.togglePasswordVisibility = () => {
            this.input.focus();
            this.props.onVisibilityChange();
        };
        this.handleFocus = () => {
            this.setState({
                inputHasFocus: true
            });
        };
        this.handleBlur = () => {
            this.setState({
                inputHasFocus: false
            });
        };
        this.handleChange = e => {
            this.props.onValueChange(e);
        };
        this.setInputRefs = el => {
            this.input = el;
            this.props.inputRef(el);
        };
        this.render = () => {
            const { label, value, passwordIsVisible, disabled, invalid, caution, valid, modified } = this.props;
            const { inputHasFocus } = this.state;
            const type = passwordIsVisible ? 'text' : 'password';
            let status;
            if (invalid) {
                status = status_1.STATUS_INVALID;
            }
            else if (caution) {
                status = status_1.STATUS_CAUTION;
            }
            else if (valid) {
                status = status_1.STATUS_VALID;
            }
            else if (modified) {
                status = status_1.STATUS_MODIFIED;
            }
            else {
                status = null;
            }
            const labelProps = {
                forId: this.id,
                text: label,
                inputHasValue: !!value,
                inputHasFocus,
                status
            };
            const inputProps = {
                type,
                placeholder: label,
                id: this.id,
                handleFocus: this.handleFocus,
                handleBlur: this.handleBlur,
                handleChange: this.handleChange,
                value,
                inputRef: this.setInputRefs,
                status,
                disabled,
                suffix: (jsx_runtime_1.jsx(visibility_1.default, { onClick: this.togglePasswordVisibility, checked: passwordIsVisible, subjectId: this.id, disabled: disabled }, void 0))
            };
            return (jsx_runtime_1.jsx(smartlabel_1.default, Object.assign({}, labelProps, { children: jsx_runtime_1.jsx(textinput_1.default, Object.assign({}, inputProps), void 0) }), void 0));
        };
    }
}
exports.FieldPasswordCompact = FieldPasswordCompact;
FieldPasswordCompact.propTypes = {
    label: prop_types_1.default.string.isRequired,
    onValueChange: prop_types_1.default.func.isRequired,
    onVisibilityChange: prop_types_1.default.func.isRequired,
    passwordIsVisible: prop_types_1.default.bool,
    inputRef: prop_types_1.default.func,
    value: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    caution: prop_types_1.default.bool,
    valid: prop_types_1.default.bool,
    modified: prop_types_1.default.bool
};
FieldPasswordCompact.defaultProps = {
    inputRef: () => { },
    passwordIsVisible: false,
    value: '',
    disabled: false,
    invalid: false,
    caution: false,
    valid: false,
    modified: false
};
exports.default = FieldPasswordCompact;
//# sourceMappingURL=field.password.compact.js.map